/**
 * Parse a path string into an array of path segments.
 *
 * Square bracket notation `a[b]` may be used to "escape" dots that would otherwise be interpreted as path separators.
 *
 * Example:
 * a -> ['a']
 * a.b.c -> ['a', 'b', 'c']
 * a[b].c -> ['a', 'b', 'c']
 * a[b.c].e.f -> ['a', 'b.c', 'e', 'f']
 * a[b][c][d] -> ['a', 'b', 'c', 'd']
 *
 * @param {string|string[]} path
 **/"use strict";

require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "toPath", {
  enumerable: true,
  get: function get() {
    return toPath;
  }
});
function toPath(path) {
  if (Array.isArray(path)) return path;
  var openBrackets = path.split("[").length - 1;
  var closedBrackets = path.split("]").length - 1;
  if (openBrackets !== closedBrackets) {
    throw new Error("Path is invalid. Has unbalanced brackets: ".concat(path));
  }
  return path.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
}